export function LicenseDao(XRAY_RESOURCE, XRayUIDaoFactory) {
    return XRayUIDaoFactory()
        .setPath(XRAY_RESOURCE.LICENSE)
        .setCustomActions({
            'get': {
                method: 'GET'
            },
            'update': {
                method: 'PUT'
            },
	        'delete': {
		        method: 'DELETE'
	        }
        })
        .getInstance();
}



// WEBPACK FOOTER //
// ./modules/xray/data/dao/license_dao.js